export {GeneralCarouselContainer as GeneralCarousel} from './container';
